/* amz-back-top — floating back-to-top button (appears after 700px, smooth scroll) */
(function () {
  'use strict';
  if (document.getElementById('amz-backtop')) return;

  var css = '.amz-backtop{position:fixed;right:18px;bottom:20px;z-index:900;width:46px;height:46px;border-radius:50%;border:none;cursor:pointer;background:rgba(20,20,23,0.88);color:#fff;display:flex;align-items:center;justify-content:center;box-shadow:0 8px 24px rgba(0,0,0,0.25);opacity:0;transform:translateY(12px);pointer-events:none;transition:opacity .25s,transform .25s,background .2s;-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)}' +
    '.amz-backtop.is-show{opacity:1;transform:translateY(0);pointer-events:auto}' +
    '.amz-backtop:hover{background:#000}' +
    'body:has(.amz-hero__sticky.is-visible) .amz-backtop{bottom:88px}' +
    '@media (max-width:749px){.amz-backtop{width:42px;height:42px;right:14px}}' +
    '@media (prefers-reduced-motion:reduce){.amz-backtop{transition:none}}';
  var s = document.createElement('style');
  s.textContent = css;
  document.head.appendChild(s);

  var btn = document.createElement('button');
  btn.id = 'amz-backtop';
  btn.className = 'amz-backtop';
  btn.setAttribute('aria-label', 'Înapoi sus');
  btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5"/><path d="M5 12l7-7 7 7"/></svg>';
  document.body.appendChild(btn);

  btn.addEventListener('click', function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });

  var hdr = document.querySelector('header');
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      btn.classList.toggle('is-show', window.scrollY > 700);
      if (hdr) hdr.classList.toggle('is-scrolled', window.scrollY > 8);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
